import type { ParseKeys } from 'i18next';
import { useTranslation } from 'react-i18next';

type ErrorReason = 'notFound' | 'expired' | 'inactive' | 'signUpMethodNotFound' | 'ipRestrictionBlocked';

const MESSAGE_TABLE: Record<ErrorReason, [ParseKeys, ParseKeys]> = {
  expired: ['auth.invitation.error.expired', 'auth.invitation.error.retryRequest'],
  inactive: ['auth.invitation.error.inactive', 'auth.invitation.error.retryRequest'],
  notFound: ['auth.invitation.error.notFound', 'auth.invitation.error.checkUrl'],
  signUpMethodNotFound: ['auth.invitation.error.noSignUpMethod', 'auth.invitation.error.contactSupport'],
  ipRestrictionBlocked: ['auth.invitation.error.ipBlocked', 'auth.invitation.error.ipBlockedDetail'],
};

type Props = {
  errorReason: ErrorReason;
};

/**
 * グループメンバーへの招待情報が見つからない場合・期限切れ等の場合に表示する内容
 */
export const ErrorMessage: React.FC<Props> = ({ errorReason }: Props) => {
  const { t } = useTranslation();
  const [reasonKey, messageKey] = MESSAGE_TABLE[errorReason];

  return (
    <>
      <div className="text-2xl font-bold">{t(reasonKey)}</div>
      <div className="pt-4">{t(messageKey)}</div>
    </>
  );
};
